import account from './account/store';

export default {
  namespaced: true,
  modules: { account },
};
